import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function DifferenceSection() {
  const differences = [{
    title: 'Experiencia Real',
    desc: 'No es teoría de un libro de texto. Es la vivencia de alguien que sintió el mismo dolor que tú sientes hoy.'
  }, {
    title: 'Lenguaje Claro',
    desc: 'Sin jerga médica incomprensible. Explicado de forma sencilla, como si hablaras con una amiga que te entiende.'
  }, {
    title: 'Enfoque Honesto',
    desc: "Sin promesas de 'cura en 3 días'. La recuperación real toma tiempo, y aquí te acompañamos en ese proceso realista."
  }];
  return <section className="py-24 bg-warm-dark text-warm-bg" data-id="element-69">
      <div className="max-w-6xl mx-auto px-6" data-id="element-70">
        <FadeIn className="text-center mb-16" data-id="element-71">
          <h2 className="text-3xl md:text-5xl font-heading mb-6" data-id="element-72">
            Por qué este ebook es diferente
          </h2>
          <p className="text-lg text-warm-bg/70 max-w-2xl mx-auto" data-id="element-73">
            El mercado está lleno de soluciones mágicas. Espalda Libre elige el
            camino de la honestidad.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-74">
          {differences.map((diff, index) => <FadeIn key={index} delay={index * 0.1} className="bg-white/5 p-8 rounded-2xl border border-white/10 backdrop-blur-sm" data-id="element-75">
              <h3 className="text-2xl font-heading text-warm-light mb-4" data-id="element-76">
                {diff.title}
              </h3>
              <p className="text-warm-bg/80 leading-relaxed" data-id="element-77">{diff.desc}</p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}